import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {notifyOnError} from "../../factory/createErrorEvent";
import {bindQueryParam} from "../../functions/routerHelper";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import CRUD from "../../../Shared/enums/CRUD";
import {Modal} from "antd";
import {DelayRender} from "../../../Shared/components/DelayRender";
import DioceseContext, {DioceseProvider} from "../DioceseContext";
import {
    diocese_createDiocese_Api,
    diocese_deleteDiocese_Api,
    diocese_updateDiocese_Api
} from "../../../../apis/diocese";
import {DetailViewForm} from "../components/DioceseForm";
import LoadingBlock from "../../../Loading/LoadingBlock";


export const useDioceses = ({
                                notifyListeners = {
                                    onCreated: undefined,
                                    onUpdated: undefined,
                                    onDeleted: undefined,
                                },
                            }) => {
    const t = useTranslate()
    const [action, setAction] = useState({type: undefined, value: undefined})

    const {
        onCreated = NullAsDefault,
        onUpdated = NullAsDefault,
        onDeleted = NullAsDefault,
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: onCreate, ...asyncCreating} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: diocese_createDiocese_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onCreated(result, data)
        },
    })

    const {handleAsyncAction: onUpdate, ...asyncUpdating} = useAsyncAction({
        onError,
        apiInfo: diocese_updateDiocese_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onUpdated(result, data)
        },
    })

    const {handleAsyncAction: onDelete, ...asyncDeleting} = useAsyncAction({
        onError,
        apiInfo: diocese_deleteDiocese_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onDeleted(result, data)
        },
    })

    const handleAction = (action, params) => {
        switch (action) {
            case CRUD.READ:
                setAction({type: action, value: params})
                break
            default:
                break
        }
    }
    const onCancel = () => {
        setAction({})
    }
    const showDetailModal = (params) => {
        return handleAction(CRUD.READ, params)
    }

    const detailModal = useMemo(() => {
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {initValues: {...action.value}}
        let modal_params = {}
        switch (action.type) {
            case CRUD.READ:
                params = {}
                modal_params = {
                    width: 600,
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('diocese information')}
                        </div>
                    ),
                }
                Content = ({...rest}) => (
                    <DioceseProvider item={action.value}>
                        <DioceseContext.Consumer>
                            {({item}) => {
                                return (
                                    <DetailViewForm
                                        {...rest}
                                        item={item}
                                        reportAccess={false}
                                    />
                                )
                            }}
                        </DioceseContext.Consumer>
                    </DioceseProvider>
                )
                break
            default:
                break
        }

        return (
            <Modal
                className="custom-modal"
                footer={null}
                onCancel={onCancel}
                open={action.type && action.type !== CRUD.DELETE}
                destroyOnHidden={true}
                {...modal_params}>
                <DelayRender lazy={true}>
                    <Wrapper>
                        {({isLoading, initialValues}) => {
                            if (!!isLoading) {
                                return <LoadingBlock/>
                            }
                            return (
                                <Content
                                    {...{
                                        onCancel,
                                        item: action.value,
                                    }}
                                    {...params}
                                    initialValues={initialValues}
                                />
                            )
                        }}
                    </Wrapper>
                </DelayRender>
            </Modal>
        )
    }, [action])

    return {
        onCreate,
        onUpdate,
        onDelete,
        asyncCreating,
        asyncUpdating,
        asyncDeleting,
        detailModal,
        showDetailModal
    }
}



